export default {
  computed: {
    recommendedAddons() {
      if (this.$store.getters.use_recommended_addons_internal_api) {
        return this.recommendedAddonsV2;
      }
      return this.recommendedAddonsV1;
    }
  }
};
